import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { brand } from 'src/theme/colors';
import { styles } from './GridItemContentFooter.styles';
import { GridItemContentFooterProps } from './GridItemContentFooter.types';
import { useGridItemContentFooterLogic } from './GridItemContentFooter.logic';
import { observer } from 'mobx-react-lite';

/**
 * ProductCounter Component
 *
 * Displays a rounded box with:
 * - a remove (trash) button on the left
 * - the current product count in the center
 * - an add (+) button on the right
 *
 * Props:
 * - productCount: number to display in the center
 * - add(): callback when the "+" is pressed
 * - subtract(): callback when the trash icon is pressed
 * - remove(): optional additional logic (not wired by default)
 */
export const GridItemContentFooter: React.FC<GridItemContentFooterProps> = observer(({ product }) => {
  const { productCount, addProduct, subtractProduct, removeProduct } = useGridItemContentFooterLogic(product);

  return (
    <View style={styles.container}>
      <View style={styles.pill}>
        <View style={styles.iconButton}>
          <Pressable onPress={productCount > 1 ? subtractProduct : removeProduct} style={styles.icon}>
            <Icon name={productCount > 1 ? ICON_NAMES.Minus : ICON_NAMES.Delete} color={brand.main.water} />
          </Pressable>
        </View>

        <Text style={styles.countText}>{productCount}</Text>

        <View style={styles.iconButton}>
          <Pressable onPress={addProduct} style={styles.icon}>
            <Icon name={ICON_NAMES.Plus} color={brand.main.water} />
          </Pressable>
        </View>
      </View>
    </View>
  );
});
